<div class="paybee-modal-header pb-0">
    <div class="d-flex justify-content-between">
        <div class="modal-title modal-main-heading">Ticket settings</div>
        <button (click)="onClose()" type="button" class="close"><span class="black-text">×</span></button>
    </div>
    
    <div class="body-1 text-gray">
        View and edit <span class="text-bold">{{campaign?.name}}</span> settings.
    </div>
  </div>
  
<div class="modal-body px-4">
    <div class="d-flex flex-column justify-content-center mb-3" [formGroup]="settingsForm">
        @if(typeData.isTicketForInPersonEvent){
            <div class="d-flex">
                <app-mdb-switch label="" formControlName="ticketForInPersonEvent" id="ticketForInPersonEvent"></app-mdb-switch>
                <div class="ml-3 d-flex align-items-center body-1">Ticket For In-Person Event</div>
            </div>
        }

        @if(typeData.isTicketForVirtualEvent){
            <div class="d-flex">
                <app-mdb-switch label="" formControlName="ticketForVirtualEvent" id="ticketForVirtualEvent"></app-mdb-switch>
                <div class="ml-3 d-flex align-items-center body-1">Ticket For Virtual Event</div>
            </div>
        }

        @if(typeData.isRaffleTicket){
            <div class="d-flex">
                <app-mdb-switch label="" formControlName="ticketForRaffle" id="ticketForRaffle"></app-mdb-switch>
                <div class="ml-3 d-flex align-items-center body-1">Ticket For Raffle</div>
            </div>
            
            <div class="d-flex ml-5">
                <app-mdb-switch label="" formControlName="ticketForBasketRaffle" id="ticketForBasketRaffle"></app-mdb-switch>
                <div class="ml-3 d-flex align-items-center body-1">Ticket For Basket Raffle</div>
            </div>
            
        }

        @if(typeData.isTicketForInPersonEvent || typeData.isRaffleTicket || typeData.isTicketForVirtualEvent){
            <div class="divider"></div>
        }

        <div class="d-flex">
            <app-mdb-switch label="" formControlName="addOnDonation" id="addOnDonation"></app-mdb-switch>
            <div class="ml-3 d-flex align-items-center body-1">Enable Add-On donation</div>
        </div>
        @if(showUpdatedMessage && latestUpdatedProperty === 'addOnDonation'){
            @if(settingsForm.controls.addOnDonation.value === false){
                <div class="body-2 green-text">Updated Add-On donation to be [OFF]</div>
            }
        }
        
        @if(settingsForm.value.addOnDonation){
            <div style="padding-left: 44px;" class="mb-2">
                <mdb-form-control class="form-fill mb-1" data-panel="general">
                    <mdb-select formControlName="addOnDonationCampaignId" data-panel="general" class="mdb-select" [filter]="true">
                        @for(campaign of donationCampaigns; track campaign.id){
                            <mdb-option [value]="campaign.id">
                                {{campaign.name}}
                            </mdb-option>
                        }
                    </mdb-select>
                    <label mdbLabel class="form-label form-label--paybee">Select Campaign for Add On Donation</label>
                    <mdb-error class="form-fill-error" *ngIf="settingsForm.controls.addOnDonationCampaignId.hasError('required') && settingsForm.controls.addOnDonationCampaignId.touched">Please select a Campaign</mdb-error>
                </mdb-form-control>
                @if(showUpdatedMessage && latestUpdatedProperty === 'addOnDonationCampaignId'){
                    @if(settingsForm.controls.addOnDonationCampaignId.value){
                        <div class="body-2 green-text w-100 text-truncate">
                            Updated Add-On donation campaign to {{ getCampaignName(settingsForm.controls.addOnDonationCampaignId.value) }}
                        </div>
                    }
                }
            </div>
        }
        
        <div class="divider"></div>
        <div class="d-flex">
            <app-mdb-switch label="" formControlName="electronicTickets" id="electronicTickets"></app-mdb-switch>
            <div class="ml-3 d-flex align-items-center body-1">Send Ticket with QR Code</div>
        </div>

        @if(showUpdatedMessage && latestUpdatedProperty === 'electronicTickets'){
            @if(settingsForm.controls.electronicTickets.value === false){
                <div class="body-2 green-text">Updated Send Ticket with QR Code to be [OFF]</div>
            } @else{
                <div class="body-2 green-text">Updated Send Ticket with QR Code to be [ON]</div>
            }
        }
    
        <div class="divider"></div>
        <div class="d-flex">
            <app-mdb-switch label="" formControlName="enforceInventory" id="enforceInventory"></app-mdb-switch>
            <div class="ml-3 d-flex align-items-center body-1">Enforce ticket inventory for this ticket campaign</div>
        </div>
        @if(showUpdatedMessage && latestUpdatedProperty === 'enforceInventory'){
            @if(settingsForm.controls.enforceInventory.value === false){
                <div class="body-2 green-text">Updated Enforce ticket inventory to be [OFF]</div>
            }
        }
        
        @if(settingsForm.value.enforceInventory){
            <div style="padding-left: 44px;" class="mb-2">
                <mdb-form-control class="form-fill mb-0" >
                    <app-mdbp-input mdbInput formControlName="campaignInventoryCount" [isCurrencyMask]="true"  label='Ticket Inventory Count'>
                        <input  #inputNameC currencyMask formControlName="campaignInventoryCount" [options]="{ allowNegative: false, prefix: '', inputMode: 1 }"   class="form-control form-control--paybee"/>
                        @if(settingsForm.controls.campaignInventoryCount.touched){
                            @if(settingsForm.controls.campaignInventoryCount.hasError('min')){
                                <mdb-error class="form-fill-error ml-0" style="margin-top: 2px;" >Please provide Global Total Inventory bigger than 0</mdb-error>
                            }
                            @else if(settingsForm.controls.campaignInventoryCount.hasError('incorrect')){
                                <mdb-error class="form-fill-error ml-0" style="margin-top: 2px;">Please provide Global Total Inventory bigger than Sold</mdb-error>
                            }
                        }
                       
                    </app-mdbp-input>
                </mdb-form-control>
                @if(settingsForm.controls.campaignInventoryCount.valid &&
                    showUpdatedMessage &&
                    latestUpdatedProperty === 'campaignInventoryCount'
                    ){
                    <div class="body-2 green-text text">
                        Updated inventory count to {{settingsForm.value.campaignInventoryCount}}
                    </div>
                }
                <div class="d-flex group-ticket-info__container px-2 py-1" style="width: fit-content;font-size: 12px; padding-left: 14px!important;"[ngStyle]="{'margin-top': isTolalInventoryValid?'10px':'20px'}">
                  <div class="group-ticket-info__icon mr-2 d-flex align-items-center">
                      <img src="img/svg/quickpay/group-ticket.svg" height="15" width="15">
                  </div>
                  <div class="group-ticket-info__content" style="font-weight: 400;">
                      {{getSold()}}
                  </div>
                </div>
        
                <div class="d-flex align-items-center">
                  <app-mdb-switch label="Hide ticket inventory for this ticket campaign" formControlName="hideCampaignInventory"></app-mdb-switch>
                  <div class="ml-2 h-100">
                      <app-text-popover
                          placement="right"
                          type="content"
                          text="Tooltip for flag: To control the number of tickets sold in this campaign but hide the number of remaining tickets left, switch this ON."
                          title=""
                      >
                      </app-text-popover>
                  </div>
                </div>
                @if(showUpdatedMessage && latestUpdatedProperty === 'hideCampaignInventory'){
                    @if(settingsForm.controls.hideCampaignInventory.value === false){
                        <div class="body-2 green-text">Updated Hide ticket inventory to be [OFF]</div>
                    } @else {
                        <div class="body-2 green-text">Updated Hide ticket inventory to be [ON]</div>
                    }
                }
            </div>
        }
        
        <div class="divider"></div>

    
        @if(typeData.isTicketForInPersonEvent || typeData.isTicketForVirtualEvent){
            <div class="d-flex">
                <app-mdb-switch label="" formControlName="saveCardEnabled" id="saveCardEnabled"></app-mdb-switch>
                <div class="ml-3 d-flex align-items-center body-1">Save Card Enabled</div>
            </div>
            @if(showUpdatedMessage && latestUpdatedProperty === 'saveCardEnabled'){
                @if(settingsForm.controls.saveCardEnabled.value === false){
                    <div class="body-2 green-text">Updated Save Card Enabled to be [OFF]</div>
                } @else {
                    <div class="body-2 green-text">Updated Save Card Enabled to be [ON]</div>
                }
            }
        }
        
        <div class="d-flex">
            <app-mdb-switch label="" formControlName="checkinEmailNotification" id="checkinEmailNotification"></app-mdb-switch>
            <div class="ml-3 d-flex align-items-center body-1">Send Check-in Email Notification</div>
        </div>
        @if(showUpdatedMessage && latestUpdatedProperty === 'checkinEmailNotification'){
            @if(settingsForm.controls.checkinEmailNotification.value === false){
                <div class="body-2 green-text">Updated Send Check-in Email Notification to be [OFF]</div>
            } @else {
                <div class="body-2 green-text">Updated Check-in Email Notification to be [ON]</div>
            }
        }
    
        @if(settingsForm.value.checkinEmailNotification){
            <div class="ml-5">
                <div class="d-flex">
                    <app-mdb-switch label="" formControlName="checkinTextNotification" id="checkinTextNotification"></app-mdb-switch>
                    <div class="ml-3 d-flex align-items-center body-1">Send Check-in Text Notification</div>
                </div>
                @if(showUpdatedMessage && latestUpdatedProperty === 'checkinTextNotification'){
                    @if(settingsForm.controls.checkinTextNotification.value === false){
                        <div class="body-2 green-text">Updated Send Check-in Text Notification to be [OFF]</div>
                    } @else {
                        <div class="body-2 green-text">Updated Send Check-in Text Notification to be [ON]</div>
                    }
                }
            </div>
        }
    </div>
</div>
